// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IFundsHistoryItemDto } from './IFundsHistoryItemDto';
import {
    IFundsHistoryItemDtoFromJSON,
    IFundsHistoryItemDtoFromJSONTyped,
    IFundsHistoryItemDtoToJSON,
    IFundsHistoryItemDtoToJSONTyped,
} from './IFundsHistoryItemDto';
import type { IPageableObject } from './IPageableObject';
import {
    IPageableObjectFromJSON,
    IPageableObjectFromJSONTyped,
    IPageableObjectToJSON,
    IPageableObjectToJSONTyped,
} from './IPageableObject';
import type { ISortOrder } from './ISortOrder';
import {
    ISortOrderFromJSON,
    ISortOrderFromJSONTyped,
    ISortOrderToJSON,
    ISortOrderToJSONTyped,
} from './ISortOrder';

/**
 * 
 * @export
 * @interface IPageFundsHistoryItemDto
 */
export interface IPageFundsHistoryItemDto {
    /**
     * 
     * @type {number}
     * @memberof IPageFundsHistoryItemDto
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageFundsHistoryItemDto
     */
    total_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageFundsHistoryItemDto
     */
    size?: number;
    /**
     * 
     * @type {Array<IFundsHistoryItemDto>}
     * @memberof IPageFundsHistoryItemDto
     */
    content?: Array<IFundsHistoryItemDto>;
    /**
     * 
     * @type {number}
     * @memberof IPageFundsHistoryItemDto
     */
    number?: number;
    /**
     * 
     * @type {Array<ISortOrder>}
     * @memberof IPageFundsHistoryItemDto
     */
    sort?: Array<ISortOrder>;
    /**
     * 
     * @type {IPageableObject}
     * @memberof IPageFundsHistoryItemDto
     */
    pageable?: IPageableObject;
    /**
     * 
     * @type {number}
     * @memberof IPageFundsHistoryItemDto
     */
    number_of_elements?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IPageFundsHistoryItemDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageFundsHistoryItemDto
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageFundsHistoryItemDto
     */
    empty?: boolean;
}

/**
 * Check if a given object implements the IPageFundsHistoryItemDto interface.
 */
export function instanceOfIPageFundsHistoryItemDto(value: object): value is IPageFundsHistoryItemDto {
    return true;
}

export function IPageFundsHistoryItemDtoFromJSON(json: any): IPageFundsHistoryItemDto {
    return IPageFundsHistoryItemDtoFromJSONTyped(json, false);
}

export function IPageFundsHistoryItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPageFundsHistoryItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
        'size': json['size'] == null ? undefined : json['size'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(IFundsHistoryItemDtoFromJSON)),
        'number': json['number'] == null ? undefined : json['number'],
        'sort': json['sort'] == null ? undefined : ((json['sort'] as Array<any>).map(ISortOrderFromJSON)),
        'pageable': json['pageable'] == null ? undefined : IPageableObjectFromJSON(json['pageable']),
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'first': json['first'] == null ? undefined : json['first'],
        'last': json['last'] == null ? undefined : json['last'],
        'empty': json['empty'] == null ? undefined : json['empty'],
    };
}

export function IPageFundsHistoryItemDtoToJSON(json: any): IPageFundsHistoryItemDto {
    return IPageFundsHistoryItemDtoToJSONTyped(json, false);
}

export function IPageFundsHistoryItemDtoToJSONTyped(value?: IPageFundsHistoryItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalPages': value['total_pages'],
        'totalElements': value['total_elements'],
        'size': value['size'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(IFundsHistoryItemDtoToJSON)),
        'number': value['number'],
        'sort': value['sort'] == null ? undefined : ((value['sort'] as Array<any>).map(ISortOrderToJSON)),
        'pageable': IPageableObjectToJSON(value['pageable']),
        'numberOfElements': value['number_of_elements'],
        'first': value['first'],
        'last': value['last'],
        'empty': value['empty'],
    };
}

